import { createContext } from 'react';
import { Context } from './types';

export const PageContext = createContext<Context | undefined>(undefined);
